import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector:    'information-dialog',
    templateUrl: './information-dialog.html',
    styleUrls:  ['./information-dialog.scss'],
    providers: [
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
  
      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
  })


  export class AppInformationDialog {
  
    constructor(
      public appInformation: MatDialogRef<AppInformationDialog>,
      @Inject( MAT_DIALOG_DATA ) public data: any) { }
    
    onNoClick(): void {
      this.appInformation.close();
    }

    //-- Event when click L03_IS_JUD_WIN
    //-- ----------------------------------------------------------------------------------------------
    checkChange( row ){
      console.log( "row.isApprove", row.isApprove);
    }
    //-- ----------------------------------------------------------------------------------------------
  
  }